import ActivationPage from './ForgotPasswordPage';

export default ActivationPage;
